<div class="vtr-widget-reboot">
	<div class="container-fluid">
		<div class="row">
			<div class="col">
				<div class="title">Reboot pending</div>
				<div class="content">
					<div class="description">
						In order to successfully install the updates your computer needs a reboot to ensure everything
						is
						running safe and
						smoothly.
					</div>
				</div>
				<div class="button-box">
					<a role="button"
						href="javascript:void(0);"
						class="button"
						(click)="onRebootClick($event)">Reboot Now</a>
				</div>
				<a role="link"
					href="javascript:void(0);"
					class="link"
					(click)="onDismissClick($event)">Dismiss</a>
			</div>
		</div>
	</div>
</div>
